import { useAuth } from '@/hooks/useAuth';
import { GreetingHero } from './widgets/GreetingHero';

export function DashboardPage() {
  const { user, roles } = useAuth();

  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
  const firstName = user?.first_name ?? user?.email ?? 'there';
  const today = new Date().toLocaleDateString('en-IN', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="space-y-6 pb-8">
      <GreetingHero greeting={greeting} firstName={firstName} today={today} roles={roles} />

    </div>
  );
}
